(function () {
  const nav = document.querySelector('[data-page-in-page-nav]');
  if (!nav) return;

  const links = nav.querySelectorAll('a[data-in-page-target]');
  if (!links.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function escapeId(id) {
    if (typeof CSS !== 'undefined' && CSS.escape) {
      return CSS.escape(id);
    }
    return id.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function getTargetEl(id) {
    try {
      return document.getElementById(id) || document.querySelector('[id="' + escapeId(id) + '"]');
    } catch (e) {
      return document.getElementById(id);
    }
  }

  const ids = Array.from(links)
    .map(function (l) {
      return l.getAttribute('data-in-page-target');
    })
    .filter(Boolean);

  function headerScrollPadding() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
  }

  function scrollToId(id) {
    const el = getTargetEl(id);
    if (!el) return;
    const offset = headerScrollPadding() + 18;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
    try {
      history.pushState(null, '', '#' + id);
    } catch (e) {
      /* ignore */
    }
    setActive(id);
  }

  function setActive(id) {
    links.forEach(function (link) {
      const target = link.getAttribute('data-in-page-target');
      const on = target === id;
      link.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const id = link.getAttribute('data-in-page-target');
      if (!id) return;
      const el = getTargetEl(id);
      if (!el) return;
      e.preventDefault();
      scrollToId(id);
    });
  });

  function updateActiveFromScroll() {
    const marker = window.innerHeight * 0.28;
    let current = ids[0];
    for (let i = 0; i < ids.length; i++) {
      const el = getTargetEl(ids[i]);
      if (!el) continue;
      const top = el.getBoundingClientRect().top;
      if (top <= marker) {
        current = ids[i];
      }
    }
    setActive(current);
  }

  let ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateActiveFromScroll();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  let hash = window.location.hash ? window.location.hash.slice(1) : '';
  if (hash) {
    try {
      hash = decodeURIComponent(hash);
    } catch (e) {
      /* keep raw */
    }
  }

  if (hash && getTargetEl(hash)) {
    if (document.readyState === 'complete') {
      scrollToId(hash);
    } else {
      window.addEventListener(
        'load',
        function () {
          scrollToId(hash);
        },
        { once: true }
      );
    }
  } else {
    updateActiveFromScroll();
  }
})();
